// Browser URL paths for personal settings pages shared across features and components
// to avoid cross-feature imports.

/** Legacy full-page path for personal AI Notetaker settings. */
export const NOTETAKER_SETTINGS_PATH = '/app/personal/ai_notetaker'
